import { ReactComponent as HassantukLogo } from "../../assets/icons/hassantuk-logo.svg";
import { Link } from "react-router-dom";
import CallIcon from "@mui/icons-material/Call";
import MailIcon from "@mui/icons-material/Mail";
import "./Footer.scss";
import { RoutePaths } from "src/resources/enum";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation([
    "common",
    "homePage",
    "assignBuildings",
    "user",
  ]);

  return (
    <footer className="app-footer">
      <div className="app-footer__boxes d-flex pb-4">
        <div className="app-footer__boxes__box py-2 gap-2">
          <Link to={RoutePaths.Home}>
            <HassantukLogo className="footer-logo" />
          </Link>
          <p className="mt-4">{t("footer.appMessage")}</p>
        </div>
        <div className="app-footer__boxes__box links-box py-2 d-flex justify-content-between">
          <div className="app-footer__boxes__box--column d-flex flex-column gap-2">
            <h5>
              <h5 > {t("footer.home")}</h5>
            </h5>
            <span className="cursor-pointer" onClick={() => (window.location.href = "/#about-us")}>
              {t("aboutUs")}
            </span>
            <span className="cursor-pointer" onClick={() => (window.location.href = "/#faqs")}>
              {t("faqs")}
            </span>
          </div>
          <div className="app-footer__boxes__box--column  d-flex flex-column gap-2">
            <h5>{t("privacy")}</h5>
            <Link to={RoutePaths.PrivacyPolicy}>{t("privacyPolicy")}</Link>
            <Link to={RoutePaths.TermsAndConditions}>
              {t("termsAndConditions")}
            </Link>
          </div>
        </div>
        <div className="app-footer__boxes__box py-2 d-flex flex-column gap-2">
          <h5>{t("contactInformation")}</h5>
          <span>{t("footer.hassantukProgram")}</span>
          <span>{t(`homePage.contactUs.address1`)}</span>
          <span>{t(`homePage.contactUs.address2`)}</span>
          <div>
            <CallIcon />
            <span className="ms-2">800 DEFEND / 800 333363</span>
          </div>
          <div>
            <MailIcon />
            <span className="ms-2">Contactus@Hassantuk.com</span>
          </div>
        </div>
      </div>
      <div className="app-footer__copyright">{t("footer.copyright")}</div>
    </footer>
  );
};

export default Footer;
